<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M5.71,5.29C5.53,5.11,5.28,5,5,5C4.45,5,4,5.45,4,6C4,6.28,4.11,6.53,4.29,6.71C4.29,6.71,4.59,7,4.59,7C4.59,7,2,7,2,7C2,7,2,2,2,2C2,2,5,2,5,2C5,2,5,3.51,5,3.51C5.52,3.57,5.99,3.8,6.34,4.16C6.34,4.16,6.34,4.16,6.34,4.16C6.34,4.16,7,4.82,7,4.82C7,4.82,7,1,7,1C7,0.45,6.55,0,6,0C6,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,15,0,15C0,15.55,0.45,16,1,16C1,16,6,16,6,16C6.55,16,7,15.55,7,15C7,15,7,11.18,7,11.18C7,11.18,6.34,11.84,6.34,11.84C6.34,11.84,6.34,11.84,6.34,11.84C5.99,12.19,5.52,12.43,5,12.49C5,12.49,5,14,5,14C5,14,2,14,2,14C2,14,2,9,2,9C2,9,4.59,9,4.59,9C4.59,9,4.29,9.29,4.29,9.29C4.11,9.47,4,9.72,4,10C4,10.55,4.45,11,5,11C5.28,11,5.53,10.89,5.71,10.71C5.71,10.71,7.71,8.71,7.71,8.71C7.89,8.53,8,8.28,8,8C8,7.72,7.89,7.47,7.71,7.29C7.71,7.29,5.71,5.29,5.71,5.29C5.71,5.29,5.71,5.29,5.71,5.29ZM15,0C15,0,10,0,10,0C9.45,0,9,0.45,9,1C9,1,9,4.82,9,4.82C9,4.82,9.66,4.16,9.66,4.16C9.66,4.16,9.66,4.16,9.66,4.16C10.01,3.81,10.48,3.57,11,3.51C11,3.51,11,2,11,2C11,2,14,2,14,2C14,2,14,7,14,7C14,7,11.41,7,11.41,7C11.41,7,11.7,6.71,11.7,6.71C11.89,6.53,12,6.28,12,6C12,5.45,11.55,5,11,5C10.72,5,10.47,5.11,10.29,5.29C10.29,5.29,8.29,7.29,8.29,7.29C8.11,7.47,8,7.72,8,8C8,8.28,8.11,8.53,8.29,8.71C8.29,8.71,10.29,10.71,10.29,10.71C10.47,10.89,10.72,11,11,11C11.55,11,12,10.55,12,10C12,9.72,11.89,9.47,11.71,9.29C11.71,9.29,11.41,9,11.41,9C11.41,9,14,9,14,9C14,9,14,14,14,14C14,14,11,14,11,14C11,14,11,12.49,11,12.49C10.48,12.43,10.01,12.2,9.66,11.84C9.66,11.84,9.66,11.84,9.66,11.84C9.66,11.84,9,11.18,9,11.18C9,11.18,9,15,9,15C9,15.55,9.45,16,10,16C10,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'MergeColumns',
} as DefineComponent
</script>
